module.exports = __webpack_public_path__ + "593a3d53/img/revit-icon.5ff0d581.svg";